import React from 'react';

/** رأس صفحات أنشطة الطالب — ألوان هادئة ومناسبة للأطفال */
function DailyExercisesHero({
  title,
  description,
  icon: Icon,
  iconClassName = 'text-sky-600',
  brandText,
}) {
  return (
    <header className="relative mt-5 overflow-hidden rounded-[1.5rem] border-[3px] border-sky-300/70 bg-gradient-to-br from-sky-100 via-amber-50/90 to-emerald-50 px-4 py-5 shadow-[0_8px_0_0_rgba(14,165,233,0.12)] sm:mt-6 sm:rounded-[1.75rem] sm:px-7 sm:py-6">
      <div className="pointer-events-none absolute -right-6 -top-6 h-28 w-28 rounded-full bg-amber-200/45 blur-2xl" aria-hidden />
      <div className="pointer-events-none absolute -bottom-8 -left-4 h-24 w-32 rounded-full bg-sky-200/35 blur-2xl" aria-hidden />
      <div className="relative flex flex-wrap items-center gap-4">
        <div
          className={`flex shrink-0 items-center justify-center rounded-2xl border-[3px] border-white/90 bg-white shadow-[0_4px_0_0_rgba(15,23,42,0.08)] ${
            brandText ? 'min-h-12 px-3.5 sm:min-h-14 sm:px-4' : 'h-12 w-12 sm:h-14 sm:w-14'
          }`}
        >
          {brandText ? (
            <span className="whitespace-nowrap text-sm font-black tracking-tight text-sky-800 sm:text-base">
              {brandText}
            </span>
          ) : (
            Icon && <Icon className={`h-7 w-7 sm:h-8 sm:w-8 ${iconClassName}`} strokeWidth={2.25} />
          )}
        </div>
        <div className="min-w-0 flex-1 text-start">
          <h1 className="text-xl font-black tracking-tight text-slate-900 sm:text-2xl md:text-3xl">{title}</h1>
          <p className="mt-1.5 text-sm font-semibold leading-snug text-slate-600 sm:text-base">{description}</p>
        </div>
      </div>
    </header>
  );
}

export default DailyExercisesHero;
